/**
 * Custom language detector based on URL path
 * Detects language from pathname: /en -> en, / -> fa
 */
export const detectLanguageFromPath = (): 'fa' | 'en' => {
  if (typeof window === 'undefined') return 'fa';
  
  const path = window.location.pathname;
  if (path.startsWith('/en')) {
    return 'en';
  }
  return 'fa';
};

